module.exports = __webpack_public_path__ + "img/Img-graph--red.7047a2ed.png";